import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LocationPerformanceChart = () => {
  const data = [
    { location: 'Plant 1', reported: 95, rectified: 82, pending: 13 },
    { location: 'Plant 2', reported: 87, rectified: 76, pending: 11 },
    { location: 'Plant 3', reported: 78, rectified: 68, pending: 10 },
    { location: 'Warehouse 1', reported: 82, rectified: 73, pending: 9 }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Location Performance Metrics</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis dataKey="location" stroke="var(--color-muted-foreground)" />
          <YAxis stroke="var(--color-muted-foreground)" />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'var(--color-card)', 
              border: '1px solid var(--color-border)',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Bar dataKey="reported" fill="#3b82f6" name="Reported" />
          <Bar dataKey="rectified" fill="#22c55e" name="Rectified" />
          <Bar dataKey="pending" fill="#f59e0b" name="Pending" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LocationPerformanceChart;